var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoOutsourcingOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 4,
    viewBox: "0 0 6 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69035 1.06952L5.02448 0.697555L4.28055 0.0292969L3.94642 0.401262L2.01937 2.54653L1.04972 1.6327L0.685854 1.28977L0 2.01751L0.36387 2.36044L1.35092 3.29067L1.34034 3.30245L1.83286 3.74488L2.06793 3.96642L2.07323 3.9608L2.08427 3.97071L2.4184 3.59875L2.49877 3.50927L2.75379 3.23868L2.74732 3.23258L4.69035 1.06952Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOutsourcingOff);
export default __webpack_public_path__ + "static/media/ico-outsourcing-off.411b2dab4ebda9dd5889579097b102ff.svg";
export { ForwardRef as ReactComponent };